import api from "../../dependencies/utils/Api";
import {
  // SIGNUP_URL,
  // LOGIN_URL,
  LOGOUT_URL,
  REFRESH_TOKEN_URL,
  // GET_USER,
  // SEND_OTP_EMIL_URL,
  // CHANGE_PASSWORD_URL,
  // VERIFY_EMAIL_OTP
} from "../../constants/ApplicationUrl";
import { storage } from "./../store/stoarage";

export const logoutService = {
  // doSignup(params) {
  //     return api.POST(SIGNUP_URL, params).
  //         then((response) => {
  //             return response
  //         });
  // },
  // doLogin(params) {
  //     return api.POST(LOGIN_URL, params).
  //     then((response) => {
  //         const { status, data } = response;
  //         if (status === 200) {
  //             return response;
  //         } else {
  //             return Promise.reject(response.data);
  //         }
  //     }).catch(e => {
  //         return Promise.reject(e);
  //     });
  // },
  // getUserData(token) {
  //     let config = { headers: { Authorization: `Bearer ${token}` } }

  //     return api.POST(GET_USER, {}, config)
  //         .then((response) => {
  //             const { status, data } = response;
  //             if (status === 200) {
  //                 return response;
  //             } else {
  //                 return Promise.reject(response.data);
  //             }
  //         })
  // },
  doLogout(refresh_token) {
    localStorage.clear();
    return api
      .POST(LOGOUT_URL, { refresh_token: refresh_token })
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          return response;
        } else {
          return Promise.reject(response.data);
        }
      });
  },

  refreshToken(token) {
    return api
      .POST(REFRESH_TOKEN_URL, {
        refresh_token: token,
      })
      .then((response) => {
        if (
          response === undefined ||
          response.data ===
            "This session has been expired (possibly due to multiple concurrent logins being attempted as the same user)."
        ) {
          storage.clear();
          window.location.href = "/login";
        } else {
          const { status, data } = response;
          if (status === 200 && data) {
            let refreshData = {
              ...storage.getAuthData(),
              access_token: data.access_token,
            };
            storage.setAuthData(refreshData);
            return data?.access_token;
          } else {
            return Promise.reject(response.data);
          }
        }
      });
  },
  // forgotPasswordsendOTP(params) {
  //     return api.POST(SEND_OTP_EMIL_URL, params).
  //         then((response) => {
  //             return response
  //         });
  // },
  // changepassword(params) {
  //     return api.POST(CHANGE_PASSWORD_URL, params).
  //         then((response) => {
  //             return response
  //         });
  // },
  // verifyemailotp(params) {
  //     return api.POST(VERIFY_EMAIL_OTP, params).
  //         then((response) => {
  //             return response
  //         });
  // },
};
